import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/liquidaciones';
import Liquidaciones from './Liquidaciones';


const ms2p = (state) => {
    let cambio_dolar = 0;
    const configuraciones = state.configuracion.configuraciones;
    if (configuraciones.cambio_dolar) {
        cambio_dolar = configuraciones.cambio_dolar.cambio_dolar;
    }
    return {
        ...state.liquidaciones,
        cambio_dolar,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Liquidaciones);
